<div id="reportdesigner" class="page-layout carded left-sidenav" style="background-color:#fafafa !important;">
    <dx-report-designer [reportUrl]="reportUrl" height="100%" style="height:100%" >
        <dxrd-request-options [getDesignerModelAction]="getDesignerModelAction" [host]="hostUrl" ></dxrd-request-options>
        <dxrd-callbacks></dxrd-callbacks>
        <dxrd-designer-model-settings [allowMDI]="true">
            <dxrd-datasource-settings [allowAddDataSource]="false" [allowRemoveDataSource]="false" [allowEditDataSource]="false"></dxrd-datasource-settings>            
            <dxrd-wizard-settings [useFullscreenWizard]="false" [enableSqlDataSource]="false"></dxrd-wizard-settings>
        </dxrd-designer-model-settings>
    </dx-report-designer>
</div>